import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/material";
import PetsIcon from "@mui/icons-material/Pets";
import FavoriteIcon from "@mui/icons-material/Favorite";
import StarIcon from "@mui/icons-material/Star";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";

const drift = keyframes`
  0%   { transform: translateY(0px)   translateX(0px)   rotate(0deg)   scale(1);    opacity:.18; }
  20%  { transform: translateY(-28px) translateX(10px)  rotate(12deg)  scale(1.08); opacity:.28; }
  45%  { transform: translateY(-14px) translateX(-8px)  rotate(-6deg)  scale(.95);  opacity:.22; }
  70%  { transform: translateY(-38px) translateX(14px)  rotate(18deg)  scale(1.05); opacity:.26; }
  100% { transform: translateY(0px)   translateX(0px)   rotate(0deg)   scale(1);    opacity:.18; }
`;
const spin = keyframes`
  0%   { transform: translateY(0px)   rotate(0deg)   scale(1);   opacity:.15; }
  33%  { transform: translateY(-24px) rotate(120deg) scale(1.1); opacity:.25; }
  66%  { transform: translateY(-42px) rotate(240deg) scale(.92); opacity:.20; }
  100% { transform: translateY(0px)   rotate(360deg) scale(1);   opacity:.15; }
`;
const bounce = keyframes`
  0%,100% { transform: translateY(0px)   rotate(-5deg)  scale(1);    opacity:.20; }
  40%      { transform: translateY(-34px) rotate(8deg)   scale(1.12); opacity:.30; }
  70%      { transform: translateY(-18px) rotate(-12deg) scale(.96);  opacity:.24; }
`;
const floatX = keyframes`
  0%,100% { transform: translateY(0px)   translateX(0px)   rotate(0deg);  opacity:.16; }
  30%      { transform: translateY(-20px) translateX(-16px) rotate(-10deg);opacity:.26; }
  60%      { transform: translateY(-32px) translateX(12px)  rotate(15deg); opacity:.22; }
`;

const animMap: Record<string, ReturnType<typeof keyframes>> = { drift, spin, bounce, floatX };

interface IconDef {
  icon: React.ReactNode;
  top?: string; bottom?: string;
  left?: string; right?: string;
  size: number;
  dur: string;
  delay: string;
  anim: "drift"|"spin"|"bounce"|"floatX";
}

export const LOGIN_ICONS: IconDef[] = [
  { icon:<PetsIcon/>,           top:"7%",  left:"5%",   size:36, dur:"8s",   delay:"0s",   anim:"drift"  },
  { icon:<FavoriteIcon/>,       top:"70%", left:"6%",   size:28, dur:"9.5s", delay:"1.8s", anim:"spin"   },
  { icon:<VaccinesIcon/>,       top:"38%", left:"2%",   size:30, dur:"7.2s", delay:"3.2s", anim:"bounce" },
  { icon:<AutoAwesomeIcon/>,    top:"85%", left:"16%",  size:24, dur:"10s",  delay:".8s",  anim:"floatX" },
  { icon:<StarIcon/>,           top:"12%", right:"6%",  size:32, dur:"7.5s", delay:"2.1s", anim:"spin"   },
  { icon:<MedicalServicesIcon/>,top:"52%", right:"4%",  size:30, dur:"8.5s", delay:"4.1s", anim:"bounce" },
  { icon:<PetsIcon/>,           top:"76%", right:"12%", size:34, dur:"6.5s", delay:"1.3s", anim:"drift"  },
  { icon:<LocalHospitalIcon/>,  top:"28%", right:"3%",  size:26, dur:"9s",   delay:"3.7s", anim:"floatX" },
  { icon:<MonitorHeartIcon/>,   top:"45%", left:"50%",  size:22, dur:"11s",  delay:"2.5s", anim:"spin"   },
];

export const SIGNUP_ICONS: IconDef[] = [
  { icon:<PetsIcon/>,           top:"6%",  left:"4%",   size:34, dur:"7.8s", delay:"0s",   anim:"drift"  },
  { icon:<StarIcon/>,           top:"68%", left:"5%",   size:26, dur:"9s",   delay:"2s",   anim:"spin"   },
  { icon:<FavoriteIcon/>,       top:"36%", left:"2%",   size:30, dur:"7s",   delay:"3.5s", anim:"bounce" },
  { icon:<AutoAwesomeIcon/>,    top:"84%", left:"18%",  size:22, dur:"10s",  delay:".7s",  anim:"floatX" },
  { icon:<VaccinesIcon/>,       top:"13%", right:"5%",  size:32, dur:"7.5s", delay:"1.8s", anim:"drift"  },
  { icon:<LocalHospitalIcon/>,  top:"50%", right:"3%",  size:28, dur:"8.5s", delay:"4s",   anim:"spin"   },
  { icon:<PetsIcon/>,           top:"74%", right:"11%", size:36, dur:"6.5s", delay:"1.2s", anim:"bounce" },
  { icon:<MedicalServicesIcon/>,top:"26%", right:"2%",  size:24, dur:"9s",   delay:"3s",   anim:"floatX" },
  { icon:<MonitorHeartIcon/>,   top:"88%", right:"22%", size:20, dur:"11s",  delay:"2.2s", anim:"spin"   },
];

const FloatingIcons: React.FC<{ icons: IconDef[] }> = ({ icons }) => (
  <>
    {icons.map((item, i) => (
      <Box
        key={i}
        sx={{
          position: "absolute",
          top: item.top, bottom: item.bottom,
          left: item.left, right: item.right,
          zIndex: 0,
          pointerEvents: "none",
          animation: `${animMap[item.anim]} ${item.dur} ease-in-out infinite`,
          animationDelay: item.delay,
          "& .MuiSvgIcon-root": {
            fontSize: item.size,
            color: "#42A5F5",
            opacity: .22,
            filter: "drop-shadow(0 0 6px rgba(66,165,245,.4))",
          },
        }}
      >
        {item.icon}
      </Box>
    ))}
  </>
);

export default FloatingIcons;
